import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { MechanicList } from '../../../business-entities/mechanicList-model';
import { NgxSpinnerService } from 'ngx-spinner';
import { MechanicService } from '../../../business-services/mechanic.service';
import { Constant } from '../../../../../../../projects/Autofacets-Core/src/app/utils/constant';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { DealerViewModel } from '../../../business-entities/dealer-view-model';
import { Utility } from '../../../../../../Autofacets-Core/src/app/utils/utility';
import { MechanicEfficiencyReportRequestModel, MechanicEfficiencyReportResponseModel, MechanicsData, MechanicDetails } from '../../../business-entities/mechanic-efficiency-report-model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { MechanicAccuracyDetailsModel, MechanicAccuracyReportRequestModel, MechanicAccuracyResponseModel, MechanicsAccuracyDataModel } from '../../../business-entities/mechanic-accuracy-report-model';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { DatePipe } from '@angular/common';
import { UserDataService } from 'src/app/DataServices/user-data.service';
@Component({
  selector: 'app-mechanic-efficiency-report',
  templateUrl: './mechanic-efficiency-report.component.html',
  styleUrls: ['./mechanic-efficiency-report.component.css'],
  providers: [DatePipe]
})
export class MechanicEfficiencyReportComponent implements OnInit {

  dealerId: string = '';
  isMechanicSelected: boolean;
  dealerList: DealerViewModel[] = [];
  isDealerRequired: boolean;
  mechanicList: MechanicList[];
  mechanicId: any;
  selectedType: string;
  mechanicEffieciencyReport: MechanicEfficiencyReportResponseModel;
  types = [
    { "type": "Summary", "typeId": 1 },
    { "type": "Detail", "typeId": 2 }
  ];
  typeId: number;
  isSummaryTypeSelected: boolean;
  isTypeRequiredToShow: boolean;
  fromDate: string;
  toDate: string;
  mechanicEfficiencyRequestModel: MechanicEfficiencyReportRequestModel;
  fromMonth: any;
  toMonth: any;
  mechanicsData: Array<MechanicsData> = [];
  months: Array<string> = [];
  dates: Array<string> = [];
  detailReportTitle: Array<string> = [];
  showData: boolean = false;
  isMechanicAccuracyScreen:boolean=false;
  mechanicAccuracyRequestModel: MechanicAccuracyReportRequestModel;
  mechanicAccuracyReport: MechanicAccuracyResponseModel;
  accuracyMechanicsData: Array<MechanicsAccuracyDataModel> = [];
  detailReportTitleAccuracy: Array<string> = [];
  mechanicEfficiencyReportExcelExportData: any[];
  mechanicEfficiencyListPDF: any[];
  
  constructor(
    private dealerBusinessService: DealerBusinessService,
    private mechanicService: MechanicService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private excelService: ExcelService,
    private datePipe: DatePipe,
    private activatedRoute:ActivatedRoute,
    private readonly userService: UserDataService
  ) {
      this.activatedRoute.data.subscribe((value:any)=>{
        if(value.data && value.data===Constant.MechanicAccuracyReport)
        {
          this.isMechanicAccuracyScreen=true;
      }
    });
  }

  ngOnInit(): void {
    this.dealerId = this.userService.currentUserValue.defaultDealerId ?? '';
    this.detailReportTitle = ['lblInvoiceHours','lblInvoiceAmountExclVAT','lblPlannedHours','lblClockedHours', 'lblPatternedHours', 'lblProductivityTitle','lblEfficiencyTitle','lblAvgHourlyRateExclVat'];
    this.detailReportTitleAccuracy = ['lblTotalWorkingHour', 'lblTotalPlannedHour', 'lblTotalUnplannedHour','Accuracy'];

    //Default selected Type - "Summary"
    this.selectedType = this.types[0].type;
    this.typeId = this.types[0].typeId;
    this.isSummaryTypeSelected = true;

    // Set Current Date in From Date and To Date
    this.fromDate = Utility.GetFormattedDate(new Date());
    this.toDate = Utility.GetFormattedDate(new Date());

    this.getUserDealers();
    if(this.dealerId != ''){
      this.GetMechanicList(this.dealerId);
      this.onSearchReport();
    }
  }

  async getUserDealers() {
    this.spinner.show();
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapDealer(response.userDealersModel);
      this.spinner.hide();
    });
  }

  onDealerSelected(dealerId: string) {
    this.mechanicList = [];
    this.mechanicId=null
    this.resetData();
    if (dealerId)
      this.isDealerRequired = false;
    else
      this.isDealerRequired = true;
    this.dealerId = dealerId;

    if (this.dealerId != null || this.dealerId != undefined) {
      this.isMechanicSelected = false;
      this.GetMechanicList(this.dealerId);
    }
  }

  resetData() {
    this.showData = false;
    this.mechanicsData = [];
    this.months = [];
    this.dates = [];
  }

  onTypeChange(typeValue: string) {
    this.resetData();
    if (typeValue == null || typeValue == undefined) {
      this.isTypeRequiredToShow = true;
      this.typeId = null;
    }
    else if (typeValue === this.types[0].type) {
      this.isSummaryTypeSelected = true;
      this.isTypeRequiredToShow = false;
      this.typeId = this.types[0].typeId;
    }
    else if (typeValue === this.types[1].type) {
      this.isSummaryTypeSelected = false;
      this.isTypeRequiredToShow = false;
      this.typeId = this.types[1].typeId;
    }
  }

  selectedMechanic(mechanicId: any) {
    
    this.isMechanicSelected = true;
    this.mechanicId = mechanicId;
  }

  async GetMechanicList(id: string) {
    this.spinner.show();
    await this.mechanicService.GetMechanicList(id, Enums.StatusCode.Active).then(response => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.mechanicList = response.responseObject;
      }
      this.spinner.hide();
    });
  }

  mapDealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach((element)=>{
        let single = Object();
        single.value = element.dealerId;
        single.text = element.dealerName;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  onSearchReport() {
    this.resetData();
    if (this.dealerId == null || this.dealerId == undefined) {
      this.isDealerRequired = true;
    }
    if (this.typeId == null || this.typeId == undefined) {
      this.isTypeRequiredToShow = true;
    }
    if ((this.dealerId != null || this.dealerId != undefined) &&
      (this.fromDate != null || this.fromDate != undefined) &&
      (this.toDate != null || this.toDate != undefined) &&
      (this.typeId != null || this.typeId != undefined)) {
      if(this.isMechanicAccuracyScreen)
      {
        this.loadAccuracyReport();
      }
      else
      {
        this.loadReport();
      }

    }
  }

  async loadAccuracyReport() {
    this.spinner.show();
    const temp = new Date();
    this.mechanicAccuracyRequestModel = {
      DealerId: this.dealerId,
      FromDate: new Date(Utility.getDateStringToDate(this.fromDate).getTime() - (temp.getTimezoneOffset() * 60000)),
      ToDate: new Date(Utility.getDateStringToDate(this.toDate).getTime() - (temp.getTimezoneOffset() * 60000)),
      MechanicId: this.mechanicId ?? 0 ,
      TypeId: this.typeId
    }

    if (!(this.mechanicAccuracyRequestModel.FromDate > this.mechanicAccuracyRequestModel.ToDate)) {
      await this.mechanicService.getMechanicAccracy(this.mechanicAccuracyRequestModel).then(response => {
        if (response.responseCode == Constant.SuccessResponseCode) {
          this.mechanicAccuracyReport = response.responseObject;
          this.mechanicAccuracyDataMapper();
          if (this.mechanicAccuracyReport != null || this.mechanicAccuracyReport != undefined) {
            this.accuracyMechanicsData = this.mechanicAccuracyReport.mechanicsData;
            this.months = this.mechanicAccuracyReport.months;
            this.dates = this.mechanicAccuracyReport.dates;
            if (this.accuracyMechanicsData != null || this.accuracyMechanicsData != undefined) {
              this.showData = true;
              this.fillUnavailableDatesAccuracyData();
            }
            else
              this.toastr.error(this.translate.instant('lblDataNotAvailable'));
          }
        }
        this.spinner.hide();
      });
    }
    else {
      this.toastr.error(this.translate.instant('lblFromToDateValidation'));
      this.spinner.hide();
    }
  }


  async loadReport() {
    this.spinner.show();
    const temp = new Date();
    this.mechanicEfficiencyRequestModel = {
      DealerId: this.dealerId,
      FromDate: new Date(Utility.getDateStringToDate(this.fromDate).getTime() - (temp.getTimezoneOffset() * 60000)),
      ToDate: new Date(Utility.getDateStringToDate(this.toDate).getTime() - (temp.getTimezoneOffset() * 60000)),
      MechanicId: this.mechanicId ?? 0 ,
      TypeId: this.typeId,
      IsNewReport:true
    }

    if (!(this.mechanicEfficiencyRequestModel.FromDate > this.mechanicEfficiencyRequestModel.ToDate)) {
      await this.mechanicService.getMechanicEfficiency(this.mechanicEfficiencyRequestModel).then(response => {
        if (response.responseCode == Constant.SuccessResponseCode) {
          this.mechanicEffieciencyReport = response.responseObject;
          if (this.mechanicEffieciencyReport !=null || this.mechanicEffieciencyReport != undefined) {
            this.mechanicsData = this.mechanicEffieciencyReport.mechanicsData;
            this.months = this.mechanicEffieciencyReport.months;
            this.dates = this.mechanicEffieciencyReport.dates;
            if (this.mechanicsData != null || this.mechanicsData != undefined) {
              this.showData = true;
              this.fillUnavailableDatesData();
            }
            else
              this.toastr.error(this.translate.instant('lblDataNotAvailable'));
          }
        }
        this.spinner.hide();
      });
    }
    else {
      this.toastr.error(this.translate.instant('lblFromToDateValidation'));
      this.spinner.hide();
    }
  }

  fillUnavailableDatesData() {
    if (this.isSummaryTypeSelected) {
      if (this.months != null || this.months != undefined) {
        this.months.forEach((month) => {
          this.mechanicsData.forEach((mechanic) => {
            let available = false;
            mechanic.mechanicsDetails.forEach((mec) => {
              if (mec.month === month) {
                available = true;
              }
            });
            if (!available) {
              let mechanicData: MechanicDetails;
              mechanicData = {
                month: month,
                mechanicDate: month,
                totalInvoiceAmount:0,
                totalClockHours: '-',
                totalInvoiceHours: '-',
                totalPlannedHours: '-',
                totalStampInHours: '-',
                efficiency: 0,
                productivity: 0,
                avgHourlyRate: 0
              }
              mechanic.mechanicsDetails.push(mechanicData);
            }
          });
        });
      }
    }
    else if (!this.isSummaryTypeSelected) {
      if (this.dates != null || this.dates != undefined) {
        this.dates.forEach((date) => {
          this.mechanicsData.forEach((mechanic) => {
            let available = false;
            mechanic.mechanicsDetails.forEach((mec) => {
              if (mec.month === date) {
                available = true;
              }
            });
            if (!available) {
              let mechanicData: MechanicDetails;
              mechanicData = {
                month: date,
                mechanicDate: date,
                totalInvoiceAmount:0,
                totalClockHours: '-',
                totalInvoiceHours: '-',
                totalPlannedHours: '-',
                totalStampInHours: '-',
                efficiency: 0,
                productivity: 0,
                avgHourlyRate: 0
              }
              mechanic.mechanicsDetails.push(mechanicData);
            }
          });
        });
      }
    }
  }


  public async exportAccuracyAsXLSX() {
    if (this.validateAccuracyExport()) {
      this.spinner.show();
      const excelData = this.mapAccuracyDataForExport();
      this.spinner.hide();
      this.excelService.exportAsExcelFile(excelData, 'Mechanic_Accuracy_Report');
    }
  }
  public async exportAccuracyAsPDF() {
    if (this.validateAccuracyExport()) {
      this.spinner.show();
      const pdfData = this.mapAccuracyDataForExport();
      const doc = new jsPDF('portrait');
  
      const headers = this.getAccuracyHeadersForExport();
      const body = pdfData.map(row => Object.values(row));
  
      autoTable(doc, {
        head: [headers],
        body: body,
        margin: { top: 3, left: 3, right: 3, bottom: 3 },
        styles: { fontSize: 8, cellPadding: { top: 2, right: 8, bottom: 2, left: 2 } },
        columnStyles: this.getAccuracyColumnStylesForExport()
      });
  
      doc.save('Mechanic_Accuracy_Report.pdf');
      this.spinner.hide();
    }
  }
  
  private validateAccuracyExport(): boolean {
    if (!this.accuracyMechanicsData || this.accuracyMechanicsData.length === 0) {
      this.toastr.error(this.translate.instant('lblDataNotAvailable'));
      return false;
    }
    return true;
  }
  
  private mapAccuracyDataForExport(): any[] {
    return this.accuracyMechanicsData
      .map((mechanic) =>
        mechanic.mechanicsDetails.map((detail) => {
          if (this.isSummaryTypeSelected) {
            return {
              [this.translate.instant('lblMechanicName')]: mechanic.mechanicName,
              [this.translate.instant('lblDate')]: this.datePipe.transform(detail.months, 'MMM-yyyy', '', 'en-US'),
              [this.translate.instant('lblAccuracy')]: detail.accuracy,
            };
          } else {
            return {
              [this.translate.instant('lblMechanicName')]: mechanic.mechanicName,
              [this.translate.instant('lblDate')]: this.datePipe.transform(detail.months, 'dd.MM.yyyy', '', 'en-US'),
              [this.translate.instant('lblTotalWorkingHour')]: detail.totalWorkingHourString,
              [this.translate.instant('lblTotalPlannedHour')]: detail.totalPlannedHourString,
              [this.translate.instant('lblTotalUnplannedHour')]: detail.totalUnPlannedHourString,
              [this.translate.instant('lblAccuracy')]: detail.accuracy,
            };
          }
        })
      )
      .reduce((acc, val) => acc.concat(val), []); 
  }
  
  
  private getAccuracyHeadersForExport(): string[] {
    if (this.isSummaryTypeSelected) {
      return [
        this.translate.instant('lblMechanicTitle'),
        this.translate.instant('lblDate'),
        this.translate.instant('lblAccuracy')
      ];
    } else {
      return [
        this.translate.instant('lblMechanicTitle'),
        this.translate.instant('lblDate'),
        this.translate.instant('lblTotalWorkingHour'),
        this.translate.instant('lblTotalPlannedHour'),
        this.translate.instant('lblTotalUnplannedHour'),
        this.translate.instant('lblAccuracy')
      ];
    }
  }
  
  private getAccuracyColumnStylesForExport(): any {
    if (this.isSummaryTypeSelected) {
      return {
        0: { cellWidth: 40, halign: 'left' ,cellPadding: {top: 2, right: 14, bottom: 2, left: 2 } },
        1: { cellWidth: 40, halign: 'left' ,cellPadding: {top: 2, right: 14, bottom: 2, left: 2 } },
        2: { cellWidth: 124, halign: 'right',cellPadding: {top: 2, right: 112, bottom: 2, left: 2 }  },
      };
    } else {
      return {
        0: { cellWidth: 44, halign: 'left' },
        1: { cellWidth: 25, halign: 'left' },
        2: { cellWidth: 35, halign: 'right' },
        3: { cellWidth: 35, halign: 'right' },
        4: { cellWidth: 35, halign: 'right' },
        5: { cellWidth: 30, halign: 'right' }
      };
    }
  }

  public get documentTypes(): typeof Enums.DocumentsType {
    return Enums.DocumentsType;
  }

  exportAsXLSX(excel: number) {
    this.GetMechanicEfficiencyReportDocument(excel);
  }

  onDownloadPDF(pdf: number) {
    this.GetMechanicEfficiencyReportDocument(pdf);
  }

  async GetMechanicEfficiencyReportDocument(type: number) {

    if (this.dealerId == null || this.dealerId == undefined) {
      this.isDealerRequired = true;
      return;
    }
    if (this.typeId == null || this.typeId == undefined) {
      this.isTypeRequiredToShow = true;
      return;
    }
    this.spinner.show();
    const temp = new Date();
    this.mechanicEfficiencyRequestModel = {
      DealerId: this.dealerId,
      FromDate: new Date(Utility.getDateStringToDate(this.fromDate).getTime() - (temp.getTimezoneOffset() * 60000)),
      ToDate: new Date(Utility.getDateStringToDate(this.toDate).getTime() - (temp.getTimezoneOffset() * 60000)),
      MechanicId: this.mechanicId ?? 0,
      TypeId: this.typeId,
      IsNewReport: true
    };

    if (!(this.mechanicEfficiencyRequestModel.FromDate > this.mechanicEfficiencyRequestModel.ToDate)) {
      await this.mechanicService.getMechanicEfficiency(this.mechanicEfficiencyRequestModel).then(response => {
        if (response.responseCode == Constant.SuccessResponseCode) {
          this.mechanicEffieciencyReport = response.responseObject;
          if (this.mechanicEffieciencyReport != null || this.mechanicEffieciencyReport != undefined) {
            this.mechanicsData = this.mechanicEffieciencyReport.mechanicsData;
            this.months = this.mechanicEffieciencyReport.months;
            this.dates = this.mechanicEffieciencyReport.dates;
            if (this.mechanicsData != null || this.mechanicsData != undefined) {
              if (type === Enums.DocumentsType.Excel) {
                this.mechanicEfficiencyReportExcelExportData = this.ExcelDataMapping(this.mechanicsData);
                this.excelService.exportAsExcelFile(this.mechanicEfficiencyReportExcelExportData, 'Mechanic_Efficiency_Report');
              } else if (type === Enums.DocumentsType.Pdf) {
                this.PDFDataMapping(this.mechanicsData);
              }
              this.showData = true;
              this.fillUnavailableDatesData();
            } else {
              this.toastr.error(this.translate.instant('lblDataNotAvailable'));
            }
          }
        }
        this.spinner.hide();
      });
    } else {
      this.toastr.error(this.translate.instant('lblFromToDateValidation'));
      this.spinner.hide();
    }
  }

  getColumnInfo(columnName: string): string {
    const columnInfoMap: { [key: string]: string } = {
      lblInvoiceHours: this.translate.instant('lblInvoiceHoursInfo'), 
      lblInvoiceAmountExclVAT: this.translate.instant('lblInvoiceAmountInfo'), 
      lblPlannedHours: this.translate.instant('lblPlannedHoursInfo'), 
      lblClockedHours: this.translate.instant('lblClockedHoursInfo'), 
      lblPatternedHours: this.translate.instant('lblPatternedHoursInfo'), 
      lblProductivityTitle: this.translate.instant('lblProductivityTitleInfo'), 
      lblEfficiencyTitle: this.translate.instant('lblEfficiencyTitleInfo'), 
      lblAvgHourlyRateExclVat: this.translate.instant('lblAvgHourlyRateTitleInfo')
    };
    return columnInfoMap[columnName] || 'No information available.';
  }

  ExcelDataMapping(data: any[]): any[] {
    const transformedData = data.reduce((acc, mechanic) => {
      const details = mechanic.mechanicsDetails.map(detail => ({
        [this.translate.instant('lblDate')]  : this.isSummaryTypeSelected ? this.datePipe.transform(detail.month, 'MMMM-yyyy','','en-US') : this.datePipe.transform(detail.mechanicDate, 'dd-MM-yyyy'),
        [this.translate.instant('lblMechanicName')] : mechanic.mechanicName,
        [this.translate.instant('lblMechanicNumber')] : mechanic.mechanicNo,
        [this.translate.instant('lblInvoiceHours')] : {
          v: detail.totalInvoiceHours,
          s: { alignment: { horizontal: "right" } } 
        },
        [this.translate.instant('lblInvoiceAmountExclVAT')] : detail.totalInvoiceAmount,
        [this.translate.instant('lblPlannedHours')]: {
          v: detail.totalPlannedHours,
          s: { alignment: { horizontal: "right" } } 
        },
        [this.translate.instant('lblPatternedHours')]
        : {
          v: detail.totalStampInHours,
          s: { alignment: { horizontal: "right" } }  
        },
        [this.translate.instant('lblClockedHours')] : {
          v: detail.totalClockHours,
          s: { alignment: { horizontal: "right" } } 
        },
       
        [this.translate.instant('lblProductivityTitle')]: {
          v: `${detail.productivity}%`,
          s: { alignment: { horizontal: "right" } } 
        },
        [this.translate.instant('lblEfficiencyTitle')]: {
          v: `${detail.efficiency}%`,
          s: { alignment: { horizontal: "right" } } 
        },  
        [this.translate.instant('lblAvgHourlyRateExclVat')]: detail.avgHourlyRate
      }));
      return acc.concat(details);
    }, []);
  
    // Sort 
    transformedData.sort((a, b) => {
      const dateA = new Date(this.isSummaryTypeSelected ? a[this.translate.instant('lblDate')] : a[this.translate.instant('lblDate')].split('-').reverse().join('-'));
      const dateB = new Date(this.isSummaryTypeSelected ? b[this.translate.instant('lblDate')] : b[this.translate.instant('lblDate')].split('-').reverse().join('-'));
      const dateComparison = dateA.getTime() - dateB.getTime();
      if (dateComparison !== 0) {
        return dateComparison;
      }
      const mechanicNameA = a[this.translate.instant('lblMechanicName')] || '';
      const mechanicNameB = b[this.translate.instant('lblMechanicName')] || '';
      return mechanicNameA.localeCompare(mechanicNameB);
    });
      return transformedData;
  }
  
  PDFDataMapping(data: any[]) {
    let supperArray = [];
    if (data && data.length > 0) {
      for (let index = 0; index < data.length; index++) {
        const mechanic = data[index];
        mechanic.mechanicsDetails.forEach((detail, detailIndex) => {
          let single = Object();
          single.rowNumber = index * mechanic.mechanicsDetails.length + detailIndex + 1;
          single.mechanicId = mechanic.mechanicId;
          single.mechanicName = mechanic.mechanicName;
          single.mechanicNo = mechanic.mechanicNo;
          single.date = this.isSummaryTypeSelected ? detail.month : detail.mechanicDate;
          single.totalInvoiceHours = detail.totalInvoiceHours;
          single.totalInvoiceAmount = detail.totalInvoiceAmount.toFixed(2);
          single.totalPlannedHours = detail.totalPlannedHours;
          single.totalClockHours = detail.totalClockHours;
          single.totalStampInHours = detail.totalStampInHours;
          single.productivity = detail.productivity.toFixed(2) + '%';
          single.efficiency = detail.efficiency.toFixed(2) + '%';
          single.avgHourlyRate = detail.avgHourlyRate.toFixed(2);
          supperArray.push(single);
        });
      }
    }
  
    // Sort 
    supperArray.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      const dateComparison = dateA.getTime() - dateB.getTime();
      if (dateComparison !== 0) {
        return dateComparison;
      }
      return a.mechanicName.localeCompare(b.mechanicName);
    });
  
    supperArray.forEach((item, index) => {
      item.rowNumber = index + 1;
    });
  
    this.mechanicEfficiencyListPDF = supperArray;
    this.cdr.detectChanges();
  
    if (this.mechanicEfficiencyListPDF && this.mechanicEfficiencyListPDF.length > 0) {
      this.spinner.show();
      const doc = new jsPDF('landscape');
  
      autoTable(doc, {
        html: '#MechanicEfficiencyPDFdata',
        margin: { top: 3, left: 3, right: 3, bottom: 3 },
        styles: { fontSize: 8 },
        columnStyles: {
          0: { cellWidth: 20, halign: 'left' },
          1: { cellWidth: 25, halign: 'left' },
          2: { cellWidth: 32, halign: 'left' },
          3: { cellWidth: 22, halign: 'left' },
          4: { cellWidth: 20, halign: 'right' },
          5: { cellWidth: 25, halign: 'right' },
          6: { cellWidth: 25, halign: 'right' },
          7: { cellWidth: 25, halign: 'right' },
          8: { cellWidth: 25, halign: 'right' },
          9: { cellWidth: 22, halign: 'right' },
          10: { cellWidth: 22, halign: 'right' },
          11: { cellWidth: 28, halign: 'right' }
        },
        didParseCell: function (data) {
          if (data.section === 'head') {
            if (data.column.index < 3) {
              data.cell.styles.halign = 'left';
            } else {
              data.cell.styles.halign = 'right';
            }
          }
        }
      });
      doc.save('Mechanic_Efficiency_Report.pdf');
      this.spinner.hide();
    }
  }

  fillUnavailableDatesAccuracyData() {
    if (this.isSummaryTypeSelected) {
      if (this.months != null || this.months != undefined) {
        this.months.forEach((month) => {
          this.accuracyMechanicsData.forEach((mechanic) => {
            let available = false;
            mechanic.mechanicsDetails.forEach((mec) => {
              if (mec.months === month) {
                available = true;
              }
            });
            if (!available) {
              let mechanicAccuracyData: MechanicAccuracyDetailsModel;
              mechanicAccuracyData = {
                months: month,
                weekDay: '-',
                totalWorkingHour: 0,
                totalPlannedHour: 0,
                totalUnPlannedHour: 0,
                accuracy:'-',
                totalPlannedHourString:'-',
                totalUnPlannedHourString:'-',
                totalWorkingHourString:'-',
              }
              mechanic.mechanicsDetails.push(mechanicAccuracyData);
            }
          });
        });
      }
    }
    else if (!this.isSummaryTypeSelected) {
      if (this.dates != null || this.dates != undefined) {
        this.dates.forEach((date) => {
          this.accuracyMechanicsData.forEach((mechanic) => {
            let available = false;
            mechanic.mechanicsDetails.forEach((mec) => {
              if (mec.months === date) {
                available = true;
              }
            });
            if (!available) {
              let mechanicAccuracyData: MechanicAccuracyDetailsModel;
              mechanicAccuracyData = {
                months: date,
                weekDay: '-',
                totalWorkingHour: 0,
                totalPlannedHour: 0,
                totalUnPlannedHour: 0,
                accuracy:'-',
                totalPlannedHourString:'-',
                totalUnPlannedHourString:'-',
                totalWorkingHourString:'-',
              }
              mechanic.mechanicsDetails.push(mechanicAccuracyData);
            }
          });
        });
      }
    }
  }


  private mechanicAccuracyDataMapper() {
    if (this.mechanicAccuracyReport.mechanicsData && this.mechanicAccuracyReport.mechanicsData.length > 0) {
      this.mechanicAccuracyReport.mechanicsData.forEach(mechanicsData => {
        mechanicsData.mechanicsDetails.forEach(mechanicsDetails => {
        mechanicsDetails.totalPlannedHourString=Utility.ConvertDecimalHourToHourMinute(mechanicsDetails.totalPlannedHour);
        mechanicsDetails.totalUnPlannedHourString=Utility.ConvertDecimalHourToHourMinute(mechanicsDetails.totalUnPlannedHour);
        mechanicsDetails.totalWorkingHourString=Utility.ConvertDecimalHourToHourMinute(mechanicsDetails.totalWorkingHour);
        mechanicsDetails.accuracy = parseFloat(mechanicsDetails.accuracy).toFixed(2) + '%';
        });
      });
    }
  }

}
